import React, { Fragment, useState } from "react";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import EndPoints from "src/Constants/EndPoints";
import CSS from "csstype";
import useApiFetch from "src/Hooks/Shared/useApiFetch";
import useLoading from "src/Hooks/Custom/useLoading";
import { useTranslation } from "react-i18next";

function BusinessPostlModal(props: any) {
  const { user } = AppStateHandler.getState();
  const { refetch, showModal, setModalVisibility, postData } = props;
  const { t, i18n } = useTranslation();

  const { data: categoriesResponse } = useApiFetch(
    [EndPoints.businessCategoris],
    {}
  );

  const { Items: categories = [] } = categoriesResponse?.data ?? {};
  const {
    id,
    title,
    category_id = categories?.length ? categories[0].id : 1,
    message,
    location,
    email: emailId = "",
    phone_number,
    images: imgs = [],
  } = postData;

  const [loader] = useState("inactive");
  const [categoryId, setCategoryId] = useState(category_id);
  const [name, setName] = useState(title);
  const [description, setDesc] = useState(message);
  const [address, setAddress] = useState(location);
  const [email, setEmail] = useState(emailId);
  const [phone, setPhone] = useState(phone_number);
  const [imgBtnText, setImgBtnText] = useState("Add Photo");
  const [images, setImages] = useState<any>([]);
  const [imageUrls, setImageUrls] = useState<any>(imgs);
  const [deleteImgs, setDeleteImgs] = useState<any>([]);
  useLoading(loader);

  const [createBusiness, { status }] = useApiMutation({
    onSettled: refetch,
    onSuccess: () => {
      setModalVisibility(false);
    },
  });

  const imageField: CSS.Properties = {
    width: "1",
    height: "1",
    opacity: "0",
    position: "absolute",
    overflow: "hidden",
    zIndex: -1,
  };

  const imgPreview: CSS.Properties = {
    width: "100%",
    height: "200px",
    padding: "10px",
  };

  const crossIcon: CSS.Properties = {
    color: "#e01515",
    position: "absolute",
    right: "0px",
    fontSize: "20px",
    cursor: "pointer",
  };

  const handleCreatePost = async () => {
    if (status === "loading") {
      return;
    }
    const data = {
      postId: id,
      subId: user?.username,
      type: "SALE",
      category_id: Number(categoryId),
      message: description,
      title: name,
      email: email,
      phone_number: phone,
      location: address,
      images: images,
      delete_images: deleteImgs,
    };
    try {
      await createBusiness({
        url: id ? EndPoints.editBusinessPost : EndPoints.createBusinessPost,
        data: data,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleImageRemove = (index: number, id: number) => {
    if (id) {
      setDeleteImgs([...deleteImgs, id]);
    }
    imageUrls.splice(index, 1);
    images.splice(index, 1);
    setImages(images);
    setImageUrls(imageUrls);
    setImgBtnText("Photos (" + images.length + ")");
  };

  const handleCategorySelected = (e: any) => {
    e.preventDefault();
    setCategoryId(e.target.value);
  };

  const fileSelectedHandler = async (imgs: any) => {
    const imgsArr = images;
    const urlsArr = imageUrls;
    for (const image of imgs) {
      const base64 = await convertToBase64(image);
      imgsArr.push(base64);
      urlsArr.push({ url: URL.createObjectURL(image) });
    }
    setImgBtnText("Photos (" + imgsArr.length + ")");
    setImages(imgsArr);
    setImageUrls(urlsArr);
  };

  const convertToBase64 = (file: File) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = function () {
        resolve(fileReader.result);
      };
      fileReader.onerror = function (error) {
        // console.log("Error: ", error);
        reject(error);
      };
    });
  };

  const hideModal = (e: any) => {
    e.preventDefault();
    setModalVisibility(false);
  };

  return (
    <Fragment>
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="add_post"
        style={{ display: showModal ? "block" : "none" }}
        role={"dialog"}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0">
            <div className="modal-body p-3 p-md-5 custom_modal">
              <div className="">
                <form>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`} >
                    <label className="mb-0">
                      {id ? t('Edit Business') : t('Business')}
                    </label>
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`} >
                    <label>{t('Name')}</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="form-control"
                      placeholder={t('Name')}
                    />
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`} >
                    <label>{t('Description')}</label>
                    <textarea
                      value={description}
                      className="form-control"
                      placeholder={t("Write a description")}
                      onChange={(e) => setDesc(e.target.value)}
                    ></textarea>
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`} >
                    <label>{t("Email")}</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control"
                      placeholder={t("Email")}
                    />
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`} >
                    <label>{t("Address")}</label>
                    <input
                      type="text"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      className="form-control"
                      placeholder={t("Address")}
                    />
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`} >
                    <label>{t("Phone Number")}</label>
                    <input
                      type="number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      className="form-control"
                      placeholder={t("Phone Number")}
                    />
                  </div>
                  <div className="form-row">
                    <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''} col-md-12`}>
                      <label>{t("Category")}</label>
                      <select
                        className="form-control fz12"
                        value={categoryId}
                        onChange={handleCategorySelected}
                      >
                        {categories.map((category: any) => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <label htmlFor="photos" className="mb-0">
                        <p className="d-inline-block btn custom_btn rounded text-secondary bg-transparent border fz15 mb-0">
                          <i
                            className={`fa fa-camera base_color fz18 ${i18n.dir()=== 'rtl'? 'ml-3':'mr-3'}`}
                            aria-hidden="true"
                          ></i>
                          {imgBtnText}
                        </p>
                      </label>
                      <input
                        id="photos"
                        style={imageField}
                        type="file"
                        accept="image/*"
                        multiple={true}
                        onChange={(e) => fileSelectedHandler(e.target.files)}
                      />
                    </div>
                    <div className="d-flex">
                      <button
                        type="button"
                        className={`btn custom_btn  border text-secondary bg-transparent fz14 ${i18n.dir() === "rtl" ? 'ml-3':'mr-3'}`}
                        onClick={hideModal}
                      >
                        {t("Cancel")}
                      </button>
                      <button
                        type="button"
                        className="btn custom_btn fz14"
                        onClick={() => handleCreatePost()}
                      >
                        <VisibilityToggle visible={status === "loading"}>
                          <span className="spinner-border spinner-border-sm"></span>
                        </VisibilityToggle>
                        {t("Submit")}
                      </button>
                    </div>
                  </div>
                </form>
                <VisibilityToggle visible={imageUrls.length !== 0}>
                  <div className="row">
                    {imageUrls.map((img: any, i: number) => {
                      return (
                        <div key={i} className="col-md-6" style={{}}>
                          <div style={{ position: "relative" }}>
                            <img
                              key={i}
                              style={imgPreview}
                              alt="London"
                              src={img.url}
                            ></img>
                            <i
                              key={i + "cross"}
                              style={crossIcon}
                              className="fa fa-times-circle"
                              aria-hidden="true"
                              onClick={() => handleImageRemove(i, img.id)}
                            ></i>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </VisibilityToggle>
              </div>
            </div>
          </div>
        </div>
      </div>
      <VisibilityToggle visible={showModal ? true : false}>
        <div
          className={`modal-backdrop fade ${showModal ? "show" : ""}`}
          onClick={() => setModalVisibility(false)}
        ></div>
      </VisibilityToggle>
    </Fragment>
  );
}

export default React.memo(BusinessPostlModal);
